// src/components/Layout/Footer.js
import React from 'react';
import './Footer.css';

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="attribution">
          <strong>Dr. Vince Castillo</strong><br/>
          Fisher College of Business, The Ohio State University
        </div>
        <div className="credits">
          Powered by{' '}
          <a
            href="https://openwebui.com"
            target="_blank"
            rel="noopener noreferrer"
            className="openwebui-link"
          >
            Open WebUI
          </a>
          {' '}&middot;{' '}
          Built with{' '}
          <a
            href="https://react.dev"
            target="_blank"
            rel="noopener noreferrer"
            className="openwebui-link"
          >
            React
          </a>
          {' '}&middot;{' '}
          <a
            href="https://www.w3.org/WAI/WCAG21/quickref/"
            target="_blank"
            rel="noopener noreferrer"
            className="openwebui-link"
            aria-label="Web Content Accessibility Guidelines 2.1 Level AA"
          >
            WCAG 2.1 AA
          </a>
        </div>
      </div>
    </footer>
  );
}
